<template lang="pug">
.searchPanel
  .simpleSearch(v-if="filtro.simplificado", key="simpleSearch")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      el-input.input(
        :placeholder="placeholder",
        v-model="filtro.campoSimples",
        class="input-with-select"
      )
        el-button.color-default(
          slot="append",
          icon="el-icon-search",
          id='botao-filtro-simplificado'
          @click="pesquisar"
        )
  .advancedSearch(v-if="!filtro.simplificado")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      .panel
        el-row(:gutter="10")
          el-col(:lg="6", :md="12", :sm="24")
            p.titulo Processo:
            el-input(
              v-model="filtro.numeroProcesso"
            )
          div
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo CPF/CNPJ do Interessado:
              el-input.input(
                v-model="filtro.cpfCnpjInteressado",
                class="input-with-select",
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Nome/Razão Social do Interessado:
              el-input(
                v-model="filtro.nomeInteressado"
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Áreas/Imóveis/Comunidades
              el-input(
                v-model="filtro.areaImovelComunidade"
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Tipo de processo:
              div
                el-select.full-width(
                  v-model='filtro.tipos',
                  placeholder='Selecione',
                  multiple,
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipios',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipios = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Status:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusConflito',
                  :key='status.codigo',
                  :label='status.descricao',
                  :value='status.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Data de criação:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataCriacao"
                name='data',
                @change="ajustarData"
              )
  .button-group
    .left-buttons
      el-button.no-padding(
        v-if="showPesquisaAvancada"
        type="text",
        @click="changePesquisa"
      ) {{ tituloPesquisa }}
      el-button.no-padding(
        type="text",
        @click="limpar"
      ) Limpar
    .right-buttons
      el-button.btn(
        v-if="!filtro.simplificado",
        type="primary",
        id='botao-filtro-avancado'
        @click="pesquisar"
      )
        i.el-icon-search
        | &nbsp Pesquisar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PermissaoHelper from '@/screens/analise/PermissaoHelper'
import { ajustarDataFinal } from '../../utils/utils'
const { tiposProcessos } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
  },

  mixins: [
    PermissaoHelper
  ],

  props: {
    showPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Pesquisar'
    }
  },

  data () {
    return {
      caixa: '',
      situacoes: [],
      setores: [],
      exibirProcessosSelecionados: false,
      statusConflito: [],
      municipios: [],
      filtro: {
        simplificado: true,
        numeroProcesso: '',
        status: '',
        campoSimples: '',
        cpfCnpjInteressado: '',
        nomeInteressado: '',
        areaImovelComunidade: '',
        tipos: [],
        municipios: [],
        dataCriacao: [],
        pagina: 0
      }
    }
  },

  async mounted () {
    this.municipios = await this.findMunicipiosByEstadoAtual()
    this.statusConflito = await this.getStatusConflito()
  },

  computed: {

    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    tituloPesquisa () {
      return this.filtro.simplificado ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },
    tiposCadastroSelect () {
      return tiposProcessos
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      getStatusConflito: 'conflito/getStatusConflito'
    }),

    limpar () {
      this.filtro = {
        numeroProcesso: '',
        status: '',
        campoSimples: '',
        cpfCnpjInteressado: '',
        nomeInteressado: '',
        areaImovelComunidade: '',
        tipos: [],
        municipios: [],
        dataCriacao: [],
        simplificado: this.filtro.simplificado,
        pagina: 0
      }
      this.exibirProcessosSelecionados = false
      this.$emit('limpar')
    },

    changePesquisa () {
      this.filtro.simplificado = !this.filtro.simplificado
      this.filtro.numeroProcesso = ''
      this.filtro.status = ''
      this.filtro.campoSimples = ''
      this.filtro.cpfCnpjInteressado = ''
      this.filtro.nomeInteressado = ''
      this.areaImovelComunidade = ''
      this.filtro.tipos = []
      this.filtro.municipios = []
      this.filtro.dataCriacao = []
    },

    pesquisar () {
      this.$emit('pesquisar', this.filtro)
    },

    ajustarData (data) {
      this.filtro.dataCriacao = ajustarDataFinal(data)
    }
  }
}
</script>

<style scoped lang="scss">
.color-default {
  color: #009d64 !important;
  font-size: 16px;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn {
    padding: 8px;
  }
}

.column-checkbox {
  padding-top: 20px;
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.titulo {
  margin: 0;
  padding: 12px 0 8px 0px;
}
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/Filtro.vue